module.exports = __webpack_public_path__ + "static/media/HeyCard.93a2d079.png";